import Hero from "../components/hero";
import SeoMeta from "../components/seo-meta";
import config from "../config";
import { getSEOPageProps } from "../lib/seo";

import styles from "./policy.module.scss";

export default function RecruitmentFraudPage({ seo }) {
  return (
    <div className="container">
      <SeoMeta {...seo} />
      <Hero title="Recruitment Fraud" />

      <div className={styles.Policy}>
        <section className={styles.Intro}>
          <p>
            Recruitment fraud happens through unsolicited emails, text messages,
            and similar unsolicited communication, claiming to have job offers
            from East Room or one of our affiliated companies. These are not
            legitimate. The fraudsters use fake websites and fake email
            addresses with one of our company’s names, brands, or logos as part
            of the fraud. This is done without our involvement, approval, or
            permission. The goal is for the fraudster to obtain your personal
            information or money.
          </p>

          <p>Examples of Recruitment Fraud:</p>

          <ul>
            <li>Ask for money for immigration attorney, visa fees, travel.</li>
            <li>
              Ask for personal information, including name, address, phone
              number, driver’s license, passport information, and bank account
              details.
            </li>
            <li>
              Emails are usually from free email accounts such as gmail or
              hotmail or use oddly branded email addresses with hyphens or city
              names.
            </li>
            <li>Use words like URGENT or IMMEDIATE ATTENTION REQUIRED.</li>
            <li>The employment is located in another country or state.</li>
            <li>Supporting documentation is poorly worded or formatted.</li>
          </ul>

          <p>What should you do if you suspect Recruitment Fraud?</p>
          <p>
            <strong>
              If you believe you have received a suspicious email, please
              forward it to info@eastroom.com
            </strong>
          </p>

          <p>
            Do not respond to unsolicited offers of employment from individuals
            claiming to work for or be associated with East Room or any of our
            affiliated companies or from individuals you do not know or trust.
            If you believe you have received a fraudulent offer of employment,
            we recommend that you also contact your local law enforcement.
          </p>
        </section>
      </div>
    </div>
  );
}

export async function getStaticProps() {
  return {
    props: {
      seo: await getSEOPageProps({ resolvedUrl: "/recruitment-fraud" })
    },
    revalidate: config.ISR_TIMING
  };
}
